import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';

import { CarouselEquipmentComponent } from '../../../shared/components/carousel-equipment/carousel-equipment.component';

@Component({
    selector: 'vision2-section-8',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        PipesModule,
        TranslateModule,
        CarouselEquipmentComponent,
    ],
    templateUrl: './section-8.component.html',
    styleUrl: './section-8.component.scss',
})
export class Section8Component {
    @Input() productData!: any;
    hasSlidesAvailable = true;

    constructor() {}

    onSlidesAvailableChange(hasSlides: boolean) {
        this.hasSlidesAvailable = hasSlides;
    }
}
